<template lang="pug">
  v-button(:loading='form.busy')
    slot
</template>

<script>
export default {
  name: 'user-input-submit',

  props: {
    label: {
      type: String,
      default: 'First name',
    },
  },
  
  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
  },
}
</script>
